<template>
  <div class="dialog_wrap" @click="closeDialog">
    <div class="dialog_wrap_middle" @click.stop="noTouch">
      <div class="dialog_wrap_close" @click="closeDialog"></div>
      <div class="dialog_wrap_content">
        <div class="wrap_content_title">预约成功</div>
        <div class="wrap_content_desc">欢迎来到仙宗大掌门的下班时间，掌门已成功预约《仙宗大掌门》，我们会在游戏公测时通过短信通知您，不见不散哟~</div>
        <div class="wrap_content_btns" v-if="isIPhone">
          <div class="btn-ok" @click="goApple">前往AppStore抢先预约</div>
        </div>
        <div class="wrap_content_btns" v-else>
          <div class="btn-ok" @click="closeDialog">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
export default {
  name: 'ActSuccess',
  props: {
    isShow: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(['isMobile', 'isIPhone', 'appleUrl'])
  },
  data () {
    return {}
  },
  mounted () {
    document.getElementsByTagName('body')[0].classList.add('noscroll');
  },
  beforeDestroy () {
    document.getElementsByTagName('body')[0].classList.remove('noscroll');
  },
  methods: {
    noTouch () {

    },
    closeDialog () {
      if (this.$route.name === 'reservation') {
        this.$emit('onClose', true)
      } else {
        this.$router.push({ name: 'reservation', query: this.$route.query })
      }
    },
    goApple () {
      this.createSuperLabel('apple', this.appleUrl)
      if (this.$route.name === 'reservation') {
        this.$emit('onClose', true)
      } else {
        this.$router.push({ name: 'reservation', query: this.$route.query })
      }
    },
    createSuperLabel (id, url) {
      let a = document.createElement('a');
      a.setAttribute('href', url);
      a.setAttribute('target', '_blank');
      a.setAttribute('id', id);
      if (!document.getElementById(id)) {
        document.body.appendChild(a);
      }
      a.click();
    }
  }
}
</script>

<style lang="scss">

</style>
